import { a as _inherits, b as _createClass, c as _classCallCheck, d as _callSuper, e as _defineProperty, f as _objectSpread2, g as _extends$4 } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { _ as _setPrototypeOf, X as _assertThisInitialized, Y as _extends$3, E as EmojiPicker, C as ConfirmationDialog, H as HSLWrapper, W as convertFromHSL, S as Slider, D as Drawer, R as RichText, b as CONSTRAINTS, c as AddButton, s as sort, t as toggle, d as remove, e as add, f as edit, Z as convertToHSL, i as triggerMixPanelEvent } from './_converter-d0e3aa12.js';
import { A as Accordion } from './index-30009c89.js';
import { T as Toggle } from './toggle-6e04c39b.js';
import { T as ToastMessage } from './toastMessage-bc50b53b.js';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var _isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var isIE =  _isBrowser ? !!document.documentElement.currentStyle : false;
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea = ( _isBrowser) && document.createElement('textarea');

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

if ( _isBrowser) {
  hiddenTextarea.setAttribute('tab-index', '-1');
  hiddenTextarea.setAttribute('aria-hidden', 'true');
  forceHiddenStyles(hiddenTextarea);
}

function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize; // Stores the value's rows count rendered in `hiddenTextarea`,
  // regardless if `maxRows` or `minRows` props are passed

  var valueRowCount = Math.floor(height / singleRowHeight);

  if (minRows !== null) {
    minHeight = singleRowHeight * minRows;

    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }

    height = Math.max(minHeight, height);
  }

  if (maxRows !== null) {
    maxHeight = singleRowHeight * maxRows;

    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }

    height = Math.min(maxHeight, height);
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount,
    valueRowCount: valueRowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  delete computedStyleCache[uid];
};

var noop = function noop() {};

var uid = 0;

var TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this._onRef = function (node) {
      _this._ref = node;
      var inputRef = _this.props.inputRef;

      if (typeof inputRef === 'function') {
        inputRef(node);
        return;
      }

      inputRef.current = node;
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event, _assertThisInitialized(_this));
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      if ( !_this._ref) {
        callback();
        return;
      }

      var nodeHeight = calculateNodeHeight(_this._ref, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount,
          valueRowCount = nodeHeight.valueRowCount;
      _this.rowCount = rowCount;
      _this.valueRowCount = valueRowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid++;
    _this._controlled = props.value !== undefined;
    _this._resizeLock = false;
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        _inputRef = _this$props.inputRef,
        _maxRows = _this$props.maxRows,
        _minRows = _this$props.minRows,
        _onHeightChange = _this$props.onHeightChange,
        _useCacheForDOMMeasurements = _this$props.useCacheForDOMMeasurements,
        props = _objectWithoutPropertiesLoose(_this$props, ["inputRef", "maxRows", "minRows", "onHeightChange", "useCacheForDOMMeasurements"]);

    props.style = _extends$3({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return createElement("textarea", _extends$3({}, props, {
      onChange: this._onChange,
      ref: this._onRef
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this._resizeComponent();
    }

    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  return TextareaAutosize;
}(Component);

TextareaAutosize.defaultProps = {
  inputRef: noop,
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EditIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#333",
  fillRule: "evenodd",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.124 5.403l3.077 3.077-9.917 9.917-3.696.62.62-3.697z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.203 4.325l3.077 3.077-3.481 3.48-3.077-3.076z"
}))));

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var TrashIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon11",
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 18.75C5 19.988 6.038 21 7.308 21h10.384C18.962 21 20 19.988 20 18.75V7.5H5v11.25zM20 3.964h-5.77L13.243 3h-1.484l-.989.964H5v1.768h15V3.964z",
  id: "Shape",
  fill: "#FFF",
  fillRule: "nonzero",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10.571v6.858M12.5 10.571v6.858M8.5 10.571v6.858",
  id: "Line",
  strokeLinecap: "square"
})))));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var StarIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.91 8.261L2 9.266l5 4.873-1.18 6.882L12 17.77l6.18 3.25L17 14.139l5-4.873-6.91-1.005L12 2z",
  fill: "none"
})));

var css_248z = ".AccordionHeader_accordionItemHeader__2B_W4 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  cursor: pointer;\n  padding-right: 40px; }\n  .AccordionHeader_accordionItemHeader__2B_W4.AccordionHeader_noPadding__30Lyx {\n    padding: 0; }\n\n.AccordionHeader_accordionItemHeaderText__1tERv {\n  font-weight: 600; }\n\n.AccordionHeader_leftColumn__2e-HP,\n.AccordionHeader_rightColumn__3AI8d {\n  display: flex;\n  align-items: center; }\n\n.AccordionHeader_rightColumn__3AI8d {\n  margin-left: auto;\n  margin-right: 0; }\n\n.AccordionHeader_icon__WumcU {\n  margin-right: 8px;\n  transition: 0.2s ease-out; }\n  .AccordionHeader_icon__WumcU.AccordionHeader_arrowIcon__3Fgv5 {\n    transform: rotate(0deg);\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    position: absolute;\n    top: 50%;\n    right: 8px;\n    margin-top: -12px; }\n  .AccordionHeader_icon__WumcU.AccordionHeader_active__2Hi2t {\n    transform: rotate(180deg); }\n  .AccordionHeader_icon__WumcU svg path {\n    transition: 0.2s ease-out; }\n\n.AccordionHeader_reorderIcon__2iEi4 {\n  width: 16px;\n  height: 16px;\n  margin-right: 16px; }\n\n.AccordionHeader_iconStarred__3od-f path {\n  fill: #ffdf9b;\n  stroke: #f9ba31; }\n";
var styles = {"accordionItemHeader":"AccordionHeader_accordionItemHeader__2B_W4","noPadding":"AccordionHeader_noPadding__30Lyx","accordionItemHeaderText":"AccordionHeader_accordionItemHeaderText__1tERv","leftColumn":"AccordionHeader_leftColumn__2e-HP","rightColumn":"AccordionHeader_rightColumn__3AI8d","icon":"AccordionHeader_icon__WumcU","arrowIcon":"AccordionHeader_arrowIcon__3Fgv5","active":"AccordionHeader_active__2Hi2t","reorderIcon":"AccordionHeader_reorderIcon__2iEi4","iconStarred":"AccordionHeader_iconStarred__3od-f"};
styleInject(css_248z);

var AccordionHeader = function AccordionHeader(_ref) {
  var onStar = _ref.onStar,
    onDelete = _ref.onDelete,
    onEdit = _ref.onEdit,
    children = _ref.children,
    ReorderIcon = _ref.ReorderIcon,
    ExpandIcon = _ref.ExpandIcon,
    index = _ref.index,
    isStarred = _ref.isStarred;
  var starredClassName = isStarred ? styles.iconStarred : "";
  return /*#__PURE__*/React.createElement("div", {
    className: styles.accordionItemHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftColumn
  }, ReorderIcon ? /*#__PURE__*/React.createElement(ReorderIcon, null) : null, /*#__PURE__*/React.createElement("span", {
    className: styles.accordionItemHeaderText
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: styles.rightColumn
  }, onStar ? /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick(e) {
      return onStar(index, e);
    },
    className: "".concat(styles.icon, " ").concat(starredClassName),
    src: StarIcon
  }) : null, onDelete ? /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick(e) {
      return onDelete(index, e);
    },
    className: styles.icon,
    src: TrashIcon
  }) : null, onEdit ? /*#__PURE__*/React.createElement(Icon, {
    onClick: function onClick(e) {
      return onEdit(index, e);
    },
    className: styles.icon,
    src: EditIcon
  }) : null, ExpandIcon ? /*#__PURE__*/React.createElement(ExpandIcon, null) : null));
};
AccordionHeader.propTypes = {
  ExpandIcon: PropTypes.node,
  ReorderIcon: PropTypes.node,
  children: PropTypes.string,
  index: PropTypes.number,
  isStarred: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onStar: PropTypes.func
};
AccordionHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionHeader",
  "props": {
    "ExpandIcon": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "ReorderIcon": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isStarred": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onDelete": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onEdit": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStar": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1 = ".QuickReply_quickReplyWrapper__1d6BF {\n  display: inline-block;\n  position: relative;\n  border: 1px solid #0e4498;\n  border-radius: 100px;\n  margin-right: 12px;\n  cursor: pointer;\n  background-color: #fff;\n  transition: 0.3s ease-out; }\n  .QuickReply_quickReplyWrapper__1d6BF.QuickReply_active__1Al0- {\n    background-color: #0e4498;\n    pointer-events: none; }\n    .QuickReply_quickReplyWrapper__1d6BF.QuickReply_active__1Al0- span {\n      color: #fff; }\n  .QuickReply_quickReplyWrapper__1d6BF:hover {\n    background-color: #7facf3; }\n  .QuickReply_quickReplyWrapper__1d6BF:active {\n    background-color: #0e4498; }\n    .QuickReply_quickReplyWrapper__1d6BF:active span {\n      color: #fff; }\n\n.QuickReply_quickReply__8crxU {\n  padding: 8px 16px;\n  transition: 0.2s ease-out;\n  text-align: center;\n  color: #0e4498;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 100px;\n  line-height: 24px;\n  white-space: nowrap;\n  pointer-events: none; }\n  .QuickReply_quickReply__8crxU.small {\n    padding: 4px 8px; }\n";
var styles$1 = {"quickReplyWrapper":"QuickReply_quickReplyWrapper__1d6BF","active":"QuickReply_active__1Al0-","quickReply":"QuickReply_quickReply__8crxU"};
styleInject(css_248z$1);

var QuickReply = function QuickReply(_ref) {
  var index = _ref.index,
    _onClick = _ref.onClick,
    text = _ref.text,
    highlighted = _ref.highlighted,
    mode = _ref.mode,
    errorClass = _ref.errorClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.quickReplyWrapper, " ").concat(highlighted ? styles$1.active : "", " ").concat(errorClass, " "),
    onClick: function onClick() {
      return _onClick("QUICK_REPLY", index);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.quickReply, " ").concat(mode)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.quickReplyMainText
  }, text)));
};
QuickReply.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  index: PropTypes.number
};
QuickReply.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuickReply",
  "props": {
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$2 = ".Text_text__f4OKp {\n  position: relative; }\n\n.Text_textMessage__1Jj-p {\n  width: 300px;\n  max-width: 300px;\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.02);\n  border-radius: 24px;\n  overflow: hidden;\n  border: 1px solid #ddd;\n  border-top-left-radius: 4px;\n  padding: 12px;\n  font-size: 14px;\n  border-top-right-radius: 24px;\n  box-sizing: border-box;\n  background-color: #f5f5f5;\n  line-height: 1.4;\n  transition: 0.2s ease-out; }\n  .Text_textMessage__1Jj-p.small {\n    padding: 8px;\n    border-radius: 16px;\n    border-top-left-radius: 4px; }\n  .Text_textMessage__1Jj-p:hover .Text_textMessageMeta__1RIWs {\n    opacity: 0.5;\n    height: 14px;\n    margin-top: 6px; }\n  .Text_textMessage__1Jj-p.Text_active__2cHy0 {\n    background-color: #0e4498;\n    color: #fff;\n    border-color: #051a3b; }\n    .Text_textMessage__1Jj-p.Text_active__2cHy0 input::placeholder {\n      color: white !important; }\n\n.Text_textMessageText__3Yhcr {\n  font-size: inherit;\n  color: inherit;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  padding: 0;\n  outline: none;\n  resize: none;\n  border: none;\n  pointer-events: none;\n  width: 100%;\n  overflow: hidden; }\n\n.Text_textMessageTextPlaceholder__3rzDO {\n  opacity: 0.3; }\n\n.Text_textMessageMeta__1RIWs {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-top: 0px;\n  font-weight: 600;\n  height: 0;\n  opacity: 0;\n  transition: 0.1s ease-out; }\n\n.Text_quickReplies__1C4VR {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  max-width: 360px; }\n\n.Text_quickRepliesArrow__2EZf8 {\n  width: 46px !important;\n  height: 46px !important;\n  z-index: 3;\n  left: auto !important;\n  right: -8px !important;\n  transition: 0.2s ease-out;\n  filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.1)); }\n  .Text_quickRepliesArrow__2EZf8 svg > g {\n    fill: #fff; }\n  .Text_quickRepliesArrow__2EZf8:before {\n    content: none !important; }\n\n.Text_quickRepliesArrowPrev__1h0eT {\n  left: -8px !important;\n  right: auto !important;\n  transform: rotate(180deg) translateY(50%) !important; }\n\n.Text_error__3Cz0z {\n  border: 1px solid #ef8b93; }\n\n.Text_overlay__2D3Kq {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  cursor: not-allowed; }\n";
var styles$2 = {"text":"Text_text__f4OKp","textMessage":"Text_textMessage__1Jj-p","textMessageMeta":"Text_textMessageMeta__1RIWs","active":"Text_active__2cHy0","textMessageText":"Text_textMessageText__3Yhcr","textMessageTextPlaceholder":"Text_textMessageTextPlaceholder__3rzDO","quickReplies":"Text_quickReplies__1C4VR","quickRepliesArrow":"Text_quickRepliesArrow__2EZf8","quickRepliesArrowPrev":"Text_quickRepliesArrowPrev__1h0eT","error":"Text_error__3Cz0z","overlay":"Text_overlay__2D3Kq"};
styleInject(css_248z$2);

var _dec, _dec2, _dec3, _dec4, _class;
var TextHSL = (_dec = EmojiPicker(), _dec2 = ToastMessage(), _dec3 = ConfirmationDialog(), _dec4 = HSLWrapper(), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function (_React$Component) {
  function TextHSL(_props) {
    var _this;
    _classCallCheck(this, TextHSL);
    _this = _callSuper(this, TextHSL, [_props]);
    _defineProperty(_this, "emptyQuickReply", {
      id: 0,
      title: "Quick Reply",
      hasUserSays: false,
      hasGogoMessage: false,
      userSays: "",
      gogoMessage: ""
    });
    _defineProperty(_this, "initialState", {
      type: "TEXT",
      quickReplyActive: false,
      quickReplies: [],
      botSays: "",
      voiceSays: "",
      autoOpenMic: false
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value ? convertFromHSL(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this.setState(value);
      }
    });
    _defineProperty(_this, "_setState", function (state, cb) {
      _this.setState(state, function () {
        _this.props.onStateChange();
        cb && cb();
      });
    });
    _defineProperty(_this, "_renderMessage", function () {
      if (_this.state.quickReplies.length > 0 && !_this.state.botSays && !_this.props.isPopupElement) return null;
      // const botSays = this.state.botSays ? this.state.botSays.replace(/\r\n|\r|\n/g, '<br />') : undefined;
      var placeholderClass = (_this.state.botSays || "").length === 0 ? styles$2.textMessageTextPlaceholder : "";
      var activeClass = _this.state.quickReplyActive === -2 ? styles$2.active : "";
      var placeholderText = _this.props.readOnly ? "No Text" : "Tap to add";
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      var errorClass = "";
      if (value.supported_response === false && !value.text) {
        errorClass = styles$2.error;
      }
      return /*#__PURE__*/React.createElement("div", {
        onClick: _this._openDrawer,
        className: "".concat(styles$2.textMessage, " ").concat(activeClass, " ").concat(_this.props.mode, " ").concat(errorClass)
      }, /*#__PURE__*/React.createElement(TextareaAutosize, {
        className: "".concat(styles$2.textMessageText, " ").concat(placeholderClass),
        value: _this.state.botSays || placeholderText,
        disabled: true
      }, _this.state.botSays), _this.props.date ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageMeta)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageDate)
      }, _this.props.date), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.textMessageUser)
      }, _this.props.user)) : null);
    });
    _defineProperty(_this, "_renderQuickReplies", function () {
      var _this$props$value2 = _this.props.value,
        value = _this$props$value2 === void 0 ? {} : _this$props$value2;
      var errorClass = "";
      if (value.supported_response === false) {
        errorClass = styles$2.error;
      }
      if (_this.state.quickReplies.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$2.quickReplies)
      }, /*#__PURE__*/React.createElement(Slider, null, _this.state.quickReplies.map(function (quickReply, i) {
        return /*#__PURE__*/React.createElement(QuickReply, {
          index: i,
          onClick: _this._openDrawer,
          highlighted: i === _this.state.quickReplyActive,
          key: i,
          text: quickReply.text,
          mode: _this.props.mode,
          errorClass: errorClass
        });
      })));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.state) return null;
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, {
        onCopy: _this._copy,
        onDone: _this._save
      }, "Edit Text"), /*#__PURE__*/React.createElement("div", {
        className: "drawer-body-overflow"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "16px",
          paddingBottom: 8
        }
      }, /*#__PURE__*/React.createElement(RichText, _extends$4({}, _this.props, {
        className: "input-margin",
        value: _this.state.botSays,
        onChange: function onChange(newValue) {
          return _this._editTopLevel("botSays", newValue);
        },
        placeholder: "Type here",
        label: "Bot Responses",
        multiline: true,
        autoFocus: _this.state.quickReplyActive === -2,
        hasVoice: true,
        hasCounter: true,
        withHeader: true
      })), _this._renderVoiceFields()), /*#__PURE__*/React.createElement(Accordion.Sortable, {
        useDragHandle: true,
        lockAxis: "y",
        onSortEnd: _this._sortQuickReply,
        helperClass: "sortableElement"
      }, _this.state.quickReplies.map(function (quickReply, i) {
        return /*#__PURE__*/React.createElement(Accordion.Item.Sortable, {
          prefixClassName: "accordion-padding",
          itemIndex: i,
          index: i,
          key: i,
          onChange: _this._toggleQuickReply,
          onAdd: _this._addQuickReply,
          active: _this.state.quickReplyActive === i,
          renderHeader: function renderHeader(_ref) {
            var ReorderIcon = _ref.ReorderIcon,
              ExpandIcon = _ref.ExpandIcon;
            return /*#__PURE__*/React.createElement(AccordionHeader, {
              index: i,
              onDelete: _this._deleteQuickReply,
              ReorderIcon: ReorderIcon,
              ExpandIcon: ExpandIcon
            }, quickReply.text || quickReply.title);
          }
        }, /*#__PURE__*/React.createElement(RichText, _extends$4({}, _this.props, {
          value: quickReply.text,
          onChange: function onChange(value) {
            _this._editQuickReply(i, "text", value, function () {
              !quickReply.hasUserSays && _this._editQuickReply(i, "userSays", value);
            });
          },
          onFocus: function onFocus() {
            return _this.state.quickReplyActive !== i && _this._toggleQuickReply(i);
          },
          placeholder: "Type here",
          label: "Quick Reply",
          autoFocus: _this.state.quickReplyActive === i,
          maxCharacters: CONSTRAINTS.MAX_QUICK_REPLY_CHARACTERS,
          activateToastMessage: _this.props.activateToastMessage,
          className: "input-margin",
          withHeader: true,
          hasCounter: true,
          isRephraseEnabled: false
        })), _this._renderQuickReplyUserSays(quickReply, i), _this._renderGogoMessage(quickReply, i));
      })), /*#__PURE__*/React.createElement(AddButton, {
        onClick: _this._addQuickReply
      }, "Add Quick Reply")));
    });
    _defineProperty(_this, "_renderVoiceFields", function () {
      if (_this._canRenderVoiceField()) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RichText, _extends$4({}, _this.props, {
          className: "input-margin",
          multiline: true,
          value: _this.state.voiceSays,
          onChange: function onChange(newValue) {
            return _this._editTopLevel("voiceSays", newValue);
          },
          placeholder: "Type here",
          label: "Voice says",
          hasVoice: true,
          isRephraseEnabled: false
        })), /*#__PURE__*/React.createElement(Toggle, {
          value: _this.state.autoOpenMic,
          onChange: function onChange(newValue) {
            return _this._editTopLevel("autoOpenMic", newValue);
          },
          label: "Auto open mic"
        }));
      }
      return /*#__PURE__*/React.createElement(AddButton, {
        nested: true,
        onClick: function onClick() {
          return _this._editTopLevel("hasVoiceFields", true);
        }
      }, "Voice support");
    });
    _defineProperty(_this, "_canRenderVoiceField", function () {
      return _this.state.hasVoiceFields || _this.props.value.voice_text;
    });
    _defineProperty(_this, "_renderQuickReplyUserSays", function (quickReply, i) {
      if (quickReply.hasUserSays) {
        return /*#__PURE__*/React.createElement(RichText, _extends$4({}, _this.props, {
          value: quickReply.userSays,
          onFocus: function onFocus() {
            return _this.state.quickReplyActive !== i && _this._toggleQuickReply(i);
          },
          onChange: function onChange(userSays) {
            return _this._editQuickReply(i, "userSays", userSays);
          },
          placeholder: "Type here",
          label: "What goes in User Messages",
          className: "input-margin",
          withHeader: true,
          isRephraseEnabled: false
        }));
      }
      return /*#__PURE__*/React.createElement(AddButton, {
        nested: true,
        onClick: function onClick() {
          return _this._editQuickReply(i, "hasUserSays", true);
        }
      }, "Add a different user message");
    });
    _defineProperty(_this, "_renderGogoMessage", function (quickReply, i) {
      if (quickReply.hasGogoMessage) {
        return /*#__PURE__*/React.createElement(RichText, _extends$4({}, _this.props, {
          value: quickReply.gogoMessage,
          onChange: function onChange(value) {
            return _this._editQuickReply(i, "gogoMessage", value);
          },
          placeholder: "Type here",
          label: "Payload Message",
          className: "input-margin",
          withHeader: true,
          isRephraseEnabled: false
        }));
      }
      return /*#__PURE__*/React.createElement(AddButton, {
        nested: true,
        onClick: function onClick() {
          return _this._editQuickReply(i, "hasGogoMessage", true);
        }
      }, "Add a Payload Message");
    });
    _defineProperty(_this, "_openDrawer", function (clickType, clickIndex) {
      var _this$props$value3 = _this.props.value,
        value = _this$props$value3 === void 0 ? {} : _this$props$value3;
      if (value.supported_response === false) {
        return;
      }
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      var quickReplyActive = -2;
      if (clickType === "QUICK_REPLY") {
        quickReplyActive = clickIndex;
      }
      if (_this.props.isPopupElement) {
        _this.props.onReverseChange("quickReplyActive", quickReplyActive);
      } else {
        _this.setState({
          quickReplyActive: quickReplyActive
        }, function () {
          _this.props.activateDrawer();
        });
      }
    });
    _defineProperty(_this, "_editTopLevel", function (key, value) {
      _this._setState(_defineProperty(_defineProperty({}, key, value), "changed", true));
    });
    _defineProperty(_this, "_sortQuickReply", function (_ref2) {
      var oldIndex = _ref2.oldIndex,
        newIndex = _ref2.newIndex;
      var quickReplies = sort(_this.state.quickReplies, oldIndex, newIndex);
      _this._setState({
        quickReplies: quickReplies,
        changed: true
      });
    });
    _defineProperty(_this, "_toggleQuickReply", function (index) {
      var quickReplyActive = toggle(_this.state.quickReplyActive, index);
      _this._setState({
        quickReplyActive: quickReplyActive
      });
    });
    _defineProperty(_this, "_deleteQuickReply", function (index, e) {
      if (e) e.stopPropagation();
      var quickReplies = remove(_this.state.quickReplies, index);
      _this._setState({
        quickReplies: quickReplies,
        changed: true
      });
    });
    _defineProperty(_this, "_addQuickReply", function (index, e) {
      if (e) e.stopPropagation();
      if (_this.state.quickReplies.length + 1 > CONSTRAINTS.MAX_QUICK_REPLIES) {
        _this.props.activateToastMessage("You can't have more than ".concat(CONSTRAINTS.MAX_QUICK_REPLIES, " quick replies"));
      } else {
        var quickReplies = add(_this.state.quickReplies, index, _this.emptyQuickReply);
        _this._setState({
          quickReplies: quickReplies,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_editQuickReply", function (index, key, value, cb) {
      var quickReplies = edit(_this.state.quickReplies, index, key, value);
      _this._setState({
        quickReplies: quickReplies,
        changed: true
      }, cb);
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$state;
      _this.props.onSave(convertToHSL(_this.state), e);
      _this.setState({
        quickReplyActive: -1
      });
      var hslElementAction = (_this$state = _this.state) !== null && _this$state !== void 0 && (_this$state = _this$state._originalHSL) !== null && _this$state !== void 0 && _this$state.isNew ? "Create" : "Edit";
      triggerMixPanelEvent(_this.state.type, hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL(_this.state));
    });
    _defineProperty(_this, "_showConfirmationDialog", function (e) {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer(e);
      } else {
        _this.props.activateConfirmationDialog({
          themed: true
        }, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer(e);
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(TextHSL, _React$Component);
  return _createClass(TextHSL, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (this.props.value !== nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$value4;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
        className: styles$2.text
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderMessage(), this._renderQuickReplies()), this._renderDrawer(), ((_this$props$value4 = this.props.value) === null || _this$props$value4 === void 0 ? void 0 : _this$props$value4.supported_response) === false && /*#__PURE__*/React.createElement("div", {
        className: styles$2.overlay
      })));
    }
  }]);
}(React.Component)) || _class) || _class) || _class) || _class);
TextHSL.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  activateToastMessage: PropTypes.func,
  copyToClipboard: PropTypes.func,
  date: PropTypes.string,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entitySearchURL: PropTypes.string,
  isPopupElement: PropTypes.bool,
  mode: PropTypes.string,
  onReverseChange: PropTypes.func,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  user: PropTypes.string,
  value: PropTypes.object,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
TextHSL.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }, {
      "name": "cb",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderMessage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderQuickReplies",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderVoiceFields",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_canRenderVoiceField",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderQuickReplyUserSays",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "quickReply",
      "type": null
    }, {
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderGogoMessage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "quickReply",
      "type": null
    }, {
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "clickType",
      "type": null
    }, {
      "name": "clickIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editTopLevel",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_sortQuickReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ oldIndex, newIndex }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleQuickReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteQuickReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addQuickReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editQuickReply",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "cb",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TextHSL",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "mode": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onReverseChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

export { AccordionHeader as A, TextareaAutosize as T, TrashIcon as a, TextHSL as b };
